<div class="page-wrapper chiller-theme toggled">
  <main class="page-content">
    <div class="container">

      <!-- Header -->
       
      <div class="row">
        <div class="col-md-6"><h3>Foreign College Fees</h3></div>
        
        <div class="col-md-6 text-end">
          <button class="btn btn-primary" (click)="openAdd()">
            <i class="fa fa-plus"></i> Add Fees
          </button>
        </div>
      </div>

      <!-- AG Grid -->
      <div class="ag-theme-alpine mt-4" style="width: 100%;">
        <ag-grid-angular
          class="ag-theme-alpine"
          [rowData]="feesList"
          [columnDefs]="columnDefs"
          [defaultColDef]="defaultColDef"
          domLayout="autoHeight"
          (gridReady)="onGridReady($event)">
        </ag-grid-angular>
      </div>

      <!-- ✅ Image Preview Modal -->
      <div class="preview-backdrop" *ngIf="previewImage" (click)="closeImagePreview()">
        <div class="preview-container" (click)="$event.stopPropagation()">
          <img [src]="previewImage" class="preview-img">
        </div>
      </div>

      <!-- Add Fees Modal -->
      <div class="backdrop" [ngStyle]="{ display: display }"></div>
      <div class="modal" [ngStyle]="{ display: display }">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              Add College Fees
              <button type="button" class="close" (click)="onCloseHandled()"><span>&times;</span></button>
            </div>
            <div class="modal-body">
              <form [formGroup]="feesForm">
                <!-- Country -->
                <label>Country</label>
                <select class="form-control" formControlName="country" (change)="onCountryChange($event.target.value)">
                  <option value="">-- Select Country --</option>
                  <option *ngFor="let c of countries" [value]="c.id">{{ c.country }}</option>
                </select>

                <!-- Course -->
                <label class="mt-2">Course</label>
                <select class="form-control" formControlName="course" (change)="onCourseChange($event.target.value)">
                  <option value="">-- Select Course --</option>
                  <option *ngFor="let crs of courses" [value]="crs.id">{{ crs.course_name }}</option>
                </select>

                <!-- College -->
                <label class="mt-2">College</label>
                <select class="form-control" formControlName="college">
                  <option value="">-- Select College --</option>
                  <option *ngFor="let clg of colleges" [value]="clg.id">{{ clg.college_name }}</option>
                </select>

                <!-- Upload Images -->
                <label class="mt-2">Upload Fees Images</label>
                <input type="file" multiple class="form-control" (change)="onFilesSelected($event)" />

                <!-- ✅ Square Image Grid Preview -->
                <div class="d-flex flex-wrap mt-2">
                  <div *ngFor="let img of selectedImages; let i = index" class="addfees-img-box">
                    <img [src]="img" />
                    <button type="button" class="delete-btn" (click)="removeImage(i)">×</button>
                  </div>
                </div>

                <!-- Submit -->
                <button class="btn btn-success mt-3" type="button" (click)="addFees()">Add Fees</button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- ✅ Separate Success Popup -->
      <div class="backdrop" *ngIf="showSuccessPopup"></div>
      <div class="modal" *ngIf="showSuccessPopup">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-success text-white">
              Success
              <button type="button" class="close text-white" (click)="closePopup()"><span>&times;</span></button>
            </div>
            <div class="modal-body text-center">
              <p>{{ popupMessage }}</p>
              <button class="btn btn-success" (click)="closePopup()">OK</button>
            </div>
          </div>
        </div>
      </div>

      <!-- ❌ Separate Error Popup -->
      <div class="backdrop" *ngIf="showErrorPopup"></div>
      <div class="modal" *ngIf="showErrorPopup">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-danger text-white">
              Error
              <button type="button" class="close text-white" (click)="closePopup()"><span>&times;</span></button>
            </div>
            <div class="modal-body text-center">
              <p>{{ popupMessage }}</p>
              <button class="btn btn-danger" (click)="closePopup()">OK</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </main>
</div>
